import { CreateRecruitmentProvider } from './Contexts/CreateRecruitmentContext';
import CreateRecruitmentPageContent from './CreateRecruitmentPageContent';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import withGooglePlacesAPICheck from '@/Routing/withGooglePlacesAPICheck';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';

const CreateRecruitmentPage = () => {
    return (
        <CreateRecruitmentProvider>
            <CreateRecruitmentPageContent />
        </CreateRecruitmentProvider>
    );
};

export default withCompanyProfileRequired(
    withTalentMeshUserRequired(withSignupChecks(withGooglePlacesAPICheck(CreateRecruitmentPage))),
);
